import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from 'react-router-dom';
import LinkText from "./LinkText";
import { getSection } from "../utils/getSection";
import { getApiVersion } from "../api/api-meta";

export default function TermsAndConditionsFooter() {
  const { pathname } = useLocation()
  const section = getSection(pathname)

  const [apiVersion, setApiVersion] = useState('')
  const getApiVersionFunc = async () => {
    const res = await getApiVersion()
    setApiVersion(res)
  }
  useEffect(() => {
    getApiVersionFunc()
  }, [])

  return <Box className="here" sx={{
    position: 'fixed',
    bottom: 0,
    bgcolor: 'background.default',
    width: '100%',
    textAlign: 'right',
    px: 1,
    display: 'flex',
    justifyContent: 'right',
    gap: 2,
  }}>

    {/* display api version */}
    <Typography
      // sx={{ mr: 2 }}
      fontSize="0.7rem"
      color='text.secondary'
    >API: {apiVersion}</Typography>

    <Typography
      component={RouterLink}
      to={`/${section}/auth/terms-and-conditions`}
      fontSize="0.7rem"
      color='text.secondary'
    >Terms & Conditions and Privacy Policy</Typography>


  </Box>
}